import {IAppError} from "@pg-mono/request-state";

/** Shape thrown by `handlePostApplicationResponse` / RTK application errors consumed in lead forms. */
export const isLeadFormSubmitAppError = (error: unknown): error is {appError: IAppError} => {
    if (typeof error !== "object" || error === null || !("appError" in error)) {
        return false;
    }

    const {appError} = error as {appError: unknown};

    return (
        typeof appError === "object" &&
        appError !== null &&
        "status" in appError &&
        typeof (appError as IAppError).status === "number" &&
        "fieldErrors" in appError &&
        typeof (appError as IAppError).fieldErrors === "object" &&
        (appError as IAppError).fieldErrors !== null &&
        "nonFieldErrors" in appError &&
        Array.isArray((appError as IAppError).nonFieldErrors)
    );
};
import {IAppError} from "@pg-mono/request-state";

/** Shape thrown by `handlePostApplicationResponse` / RTK application errors consumed in lead forms. */
export const isLeadFormSubmitAppError = (error: unknown): error is {appError: IAppError} => {
    if (typeof error !== "object" || error === null || !("appError" in error)) {
        return false;
    }

    const {appError} = error as {appError: unknown};

    return (
        typeof appError === "object" &&
        appError !== null &&
        "status" in appError &&
        typeof (appError as IAppError).status === "number" &&
        "fieldErrors" in appError &&
        typeof (appError as IAppError).fieldErrors === "object" &&
        (appError as IAppError).fieldErrors !== null &&
        "nonFieldErrors" in appError &&
        Array.isArray((appError as IAppError).nonFieldErrors)
    );
};
